import { useEffect, useState } from 'react';

import { useGame } from '@/store/game';
import { notify } from '@/telegram/haptics';

export interface SecretWarningProps {
  /** Кому адресовано задание: остальным отворачиваться. */
  assigneeName: string;
}

/**
 * 06 · Секретное задание, первый экран: предупреждение до текста.
 *
 * Порядок здесь и есть механика. Сигнал «спрячь экран» обязан прийти раньше,
 * чем глаз доберётся до задания, поэтому текста в разметке ещё нет — он
 * появится только после подтверждения (`acknowledgeSecret`). Предупреждение
 * снимается один раз на карточку: новая закроется снова, даже если игрок тот же.
 */
export function SecretWarning({ assigneeName }: SecretWarningProps) {
  const acknowledge = useGame((s) => s.acknowledgeSecret);

  // Сигнал «спрячь экран» приходит раньше, чем глаз доберётся до текста:
  // в том и смысл этого экрана.
  useEffect(() => notify('warning'), []);

  // Счётчик показывает, сколько экран уже открыт. Он ничего не запрещает —
  // за столом ждут, и видимая секунда торопит вернее любой надписи.
  const [seconds, setSeconds] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setSeconds((value) => value + 1), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <button
      type="button"
      onClick={acknowledge}
      className="relative flex min-h-screen w-full flex-col justify-between border-2 border-acc bg-ground px-5 text-left text-ink"
      style={{ paddingTop: 'var(--clown-safe-top)', paddingBottom: 'var(--clown-safe-bottom)' }}
    >
      <span aria-hidden className="pointer-events-none absolute inset-0 bg-tape opacity-15" />

      <div className="relative bg-acc px-4 py-6 text-ground">
        <p className="font-display text-shout">НЕ ЧИТАЙ ВСЛУХ</p>
      </div>

      <p className="relative text-meta uppercase tracking-widest text-acc">
        Только для {assigneeName} · остальные отвернулись
      </p>

      <div className="relative flex h-act items-center justify-between bg-acc px-4 text-ground">
        <div>
          <p className="font-display text-row">ПРОЧИТАЛ</p>
          <p className="text-meta uppercase tracking-widest">Тап откроет задание</p>
        </div>
        <span className="font-display text-row tabular-nums">{seconds}</span>
      </div>
    </button>
  );
}
